import React from 'react'

export function Copyright() {
  return <footer>© 2012-{new Date().getFullYear()} Leko</footer>
}
